import p5 from 'p5';
import { sketch } from './sketch.js';

new p5(sketch, document.getElementById('sketch'));
